import { render, staticRenderFns } from "./important-message-bar-icon.vue?vue&type=template&id=9be2cb0a&functional=true&"
import script from "./important-message-bar-icon.vue?vue&type=script&lang=js&"
export * from "./important-message-bar-icon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports